import React from 'react';
// import PropTypes from 'prop-types';
import NavTab, { NavTabItem } from 'partial/components/NavTab';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import AppCmsContainer from 'core-modules/app-cms/container/AppCmsContainer';
import CategoryContainer from 'core-modules/category/container/CategoryContainer';
import IdTemplate from 'sandbox/id-template';

function SettingRoutes() {
  const match = useRouteMatch();
  return (
    <>
      <NavTab>
        <NavTabItem
          to={`${match.url}/channel-category`}
          label="Channel Category"
        />
        <NavTabItem to={`${match.url}/app-cms`} label="App Cms" />
        <NavTabItem to={`${match.url}/id-template`} label="ID Template" />
      </NavTab>
      <Switch>
        <Route path={`${match.path}/channel-category`}>
          <CategoryContainer />
        </Route>
        <Route path={`${match.path}/app-cms`}>
          <AppCmsContainer />
        </Route>
        <Route path={`${match.path}/id-template`}>
          <IdTemplate />
        </Route>
        <Redirect to={`${match.path}/channel-category`} />
      </Switch>
    </>
  );
}

SettingRoutes.propTypes = {};

export default SettingRoutes;
